// Common
import { ReactElement, useCallback, useState, useReducer, useEffect } from 'react'
import { useHistory } from 'react-router-dom'

// Styles
import { makeStyles } from '@material-ui/styles'

// Interface
import { Item } from '../interface'

//Reducer
import quizReducer from '../reducers/quiz'

// Components
import QuizHeader from './components/header'
import QuizWrapper from './components/wrapper'
import HouseIcon from '../svg-icons/house-icon'
import AppartmentIcon from '../svg-icons/appartment-icon'
import Row from 'shared-components/row'
import useMobile from 'components/hooks/useMobile'
import QuizContext from '../quiz/components/context'
import QuizBody from 'components/quiz/components/body'
import Typography from 'shared-components/typography'
import Errors from 'components/common/Errors'

const useStyle = makeStyles({
	body: {
		backgroundColor: '#fff',
		borderRadius: 60,
		boxShadow: '0px 4px 10px rgba(138, 84, 232, 0.2)',
		flex: 1,
		marginTop: -54,
		margin: 'auto',
		marginBottom: 54,
		width: 'calc(100% - 80px)',
		justifyContent:'center',
		alignItems: 'center',
	},
	buttonText: {
		textAlign: 'center',
		width: '100%',
		marginTop: 20,
	},
})

type headerTitle = 'default' | 'appartment' | 'house'

export default function Quiz(): ReactElement {
	const mobile = useMobile()
	const [type, setType] = useState<headerTitle>('default')
	const [questions, setQuestions] = useState<Item[]>([])
	const [current, setCurrent] = useState<number>(0)
	const [state, dispatch] = useReducer(quizReducer, { status: 'empty' })

	useEffect(() => {
		const ignore = false
		dispatch({ type: 'request' })

		fetch(`${process.env.REACT_APP_API_URL}/questions`, {
			method: 'GET',
		})
			.then(response => {
				if (response.status !== 200)
					return
				return response.json()
			})
			.then(response => {
				setQuestions(response.rows)
				{ if (!ignore) dispatch({ type: 'success', results: response.rows })}
			})
			.catch(error => dispatch({ type: 'failure', error }))
		sessionStorage.clear()
	}, [])

	useEffect(() => {
		setType(type)
	}, [type])

	const history = useHistory()
	const classes = useStyle()

	const handleClick = useCallback(type => {
		setType(type)
	}, [])

	const location = {
		id: 1,
		name: 'What is the location?',
		step: 'location',
		type: 'location',
	}
	const info = {
		id: 2,
		name: 'Personal information',
		step: 'info',
		type: 'info',
	}

	const forms = [info, location]

	const appartment_questions = questions.map(i => i).filter(i => i.property === 'appartment').reverse()
	Array.prototype.push.apply(appartment_questions, forms)

	const house_questions = questions && questions.map(i => i).filter(i => i.property === 'house').reverse()
	Array.prototype.push.apply(house_questions, forms)

	const handleHeaderTitle = useCallback(() => {
		switch(type){
		case 'appartment':
			return 'Appartment'
		case 'house':
			return 'House'
		default:
			return 'Type of property'
		}
	}, [type])

	const subtitle = type !== 'default' ? 'Please answer a few questions' : 'Please choose your type of property'

	const main_questions = type === 'appartment' ? appartment_questions : house_questions
	const main_questions_length = main_questions && main_questions.length + 1

	const itemsId: number[] = []
	for (let i = 1; i < main_questions_length; i++)
		itemsId.push(i)

	const data = main_questions && main_questions.map((obj, i) => ({...obj, done: itemsId[i]}))

	const handleChange = useCallback(() => {
		const nextQ = current + 1
		if (current >= main_questions.length - 1)
			history.push('/done')
		else
			setCurrent(nextQ)
	}, [current])

	const handleBack = useCallback(() => {
		const nextQ = current - 1
		if (current < 1){
			setType('default')
			history.push('/')
		}else{
			setCurrent(nextQ)
		}
	}, [current])

	return (
		<>
			<QuizWrapper>
				<QuizHeader
					title={handleHeaderTitle()}
					subtitle={subtitle}
				/>
				<Row className={classes.body} style={ mobile ? { marginBottom: '15px' } : {}}>
					<>
						{type === 'default' ?
							<>
								<div onClick={() => handleClick('appartment')}>
									<AppartmentIcon style={ mobile ? { marginRight: '38px', width: '80px', height: '100%' } : { marginRight: '100px', width: '115px', height: '100%' }} />
								</div>
								<div onClick={() => handleClick('house')}>
									<HouseIcon style={ mobile ? { width: '80px', height: '100%' } : { width: '115px', height: '100%' }} />
								</div>
							</>
							:
							<>
								{state.status === 'loading' &&
									<QuizBody>
										<Typography>Loading...</Typography>
									</QuizBody>
								}
								{state.status === 'success' &&
									<>
										{data.length &&
											<QuizContext
												questions={data}
												question={data[current]}
												id={data[current].id}
												onClickNext={handleChange}
												goBack={handleBack}
												number={data[current].done}
											/>
										}
									</>
								}
								{state.status === 'error' && <Errors error={state.error} />}
							</>
						}
					</>
				</Row>
			</QuizWrapper>
		</>
	)
}
